import React from 'react';
import PropTypes from 'prop-types';
import styles from './index.css';

class SurveyTitle extends React.PureComponent {
    static propTypes = {
        id: PropTypes.string,
        title: PropTypes.string,
    };

    render() {
        const { id, title } = this.props;

        return (
            <div className={styles.survey_title}>
                <div className={styles.box}>
                    <span className={styles.logo} />
                    <span className={styles.icon} />
                </div>
                <div className={styles.title}>
                    <a href={`//vote.ifeng.com/survey/${id}`} target="_blank">
                        {title}
                    </a>
                </div>
            </div>
        );
    }
}

export default SurveyTitle;
